//--------------- IMPORTAÇÕES ---------------//
import { Plus } from "lucide-react";
import { useContext } from "react";
import { IntegracoesContext } from "../context/IntegracoesContext";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function Main() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { integrations, setIntegrations } = useContext(IntegracoesContext); // Estado que armazena a lista de Integrações
    const { isOpenModalCreateIntegration, setIsOpenModalCreateIntegration } = useContext(IntegracoesContext); // Estado que armazena se o Modal de Criar Integração está aberto ou não




    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* BUTTON DE CRIAR NOVA INTEGRAÇÃO */}
            <button
                onClick={() => setIsOpenModalCreateIntegration(true)}
                className="bg-brand-600 hover:bg-brand-700 p-2 rounded flex items-center gap-2 h-[40px]"
            >
                <Plus className="w-2 h-2" /> Nova Integração
            </button>

        </>
    )
}